let IntlMessageFormat = require('intl-messageformat');

let messageCache = {};

/**
 * Convert HomeAway full locale to format needed
 * @param ourLocale String a HomeAway full locale, ex: en_US_HA
 * @returns String locale BCP 47 language tag required by IntlMessageFormat, ex: en-US
 */
function convertLocale(fullLocale) {
    return fullLocale.substring(0, 5).replace('_', '-');
}

/**
 * Read a message via a key and variable options object
 * @param key String
 * @param options Object containing name/value pairs
 */
function message(key, options) {
    let locale = options.data.root.fullLocale;
    let translations = options.data.root.translations;
    let msg;
    let output;

    // START ---------------- PERFORMANCE TEST ------------------
    // Fast return values we deemed appropriate to cache.
    if (
        typeof messageCache[key] !== 'undefined' &&
        typeof messageCache[key][locale] !== 'undefined'
    ) {
        // If the cached raw value still matches the bizop response
        // This is to prevent caching too strictly and not allowing the bizop to update it's keys.
        if (messageCache[key][locale].rawValue === translations[key]) {
            return messageCache[key][locale].formattedValue;
        }

        // If the rawValue doesn't match what the bizop is sending down, delete the cache for that key / locale.
        delete messageCache[key][locale];
    }
    // END ---------------- PERFORMANCE TEST ------------------

    if (typeof translations[key] !== 'undefined') {
        let messageFormatLocale = convertLocale(locale);
        msg = new IntlMessageFormat(translations[key], messageFormatLocale);

        // options.hash contains parameters you pass to the handlebars helper
        // Note: A value MUST be supplied for every argument in the message pattern the instance was constructed with.
        output = msg.format(options.hash);

        // START ---------------- PERFORMANCE TEST ------------------
        // If the raw value and formatted output are the same, it has no variable substitution and can safetly be cached.
        if (translations[key] === output) {
            if (typeof messageCache[key] === 'undefined') {
                messageCache[key] = {};
            }
            messageCache[key][locale] = {
                rawValue: translations[key],
                formattedValue: output,
            };
        }
        // END ---------------- PERFORMANCE TEST ------------------

        return output;
    }

    // fallback ex: '??? the.key.does.not.exist ???'
    return `??? ${key} ???`;
}

module.exports = message;
